export type CountryInfo = {
  flag: string;
  country: string;
  contestant: string;
  song: string;
};

export const allCountries: Record<string, CountryInfo> = {
  austria: {
    flag: '🇦🇹',
    country: 'Austria',
    contestant: 'Cosmó',
    song: 'Tanzschein',
  },
  denmark: {
    flag: '🇩🇰',
    country: 'Denmark',
    contestant: 'Søren Torpegaard Lund',
    song: 'Før Vi Går Hjem',
  },
  germany: {
    flag: '🇩🇪',
    country: 'Germany',
    contestant: 'Sarah Engels',
    song: 'Fire',
  },
  israel: {
    flag: '🇮🇱',
    country: 'Israel',
    contestant: 'Noam Bettan',
    song: 'Michelle',
  },
  belgium: {
    flag: '🇧🇪',
    country: 'Belgium',
    contestant: 'Essyla',
    song: 'Dancing on the Ice',
  },
  albania: {
    flag: '🇦🇱',
    country: 'Albania',
    contestant: 'Alis',
    song: 'Nân',
  },
  greece: {
    flag: '🇬🇷',
    country: 'Greece',
    contestant: 'Akylas',
    song: 'Ferto',
  },
  ukraine: {
    flag: '🇺🇦',
    country: 'Ukraine',
    contestant: 'Leléka',
    song: 'Ridnym',
  },
  australia: {
    flag: '🇦🇺',
    country: 'Australia',
    contestant: 'Delta Goodrem',
    song: 'Eclipse',
  },
  serbia: {
    flag: '🇷🇸',
    country: 'Serbia',
    contestant: 'Lavina',
    song: 'Kraj Mene',
  },
  malta: {
    flag: '🇲🇹',
    country: 'Malta',
    contestant: 'Aidan',
    song: 'Bella',
  },
  czechia: {
    flag: '🇨🇿',
    country: 'Czechia',
    contestant: 'Daniel Zizka',
    song: 'Crossroads',
  },
  bulgaria: {
    flag: '🇧🇬',
    country: 'Bulgaria',
    contestant: 'Dara',
    song: 'Bangaranga',
  },
  croatia: {
    flag: '🇭🇷',
    country: 'Croatia',
    contestant: 'Lelek',
    song: 'Andromeda',
  },
  unitedKingdom: {
    flag: '🇬🇧',
    country: 'United Kingdom',
    contestant: 'Look Mum No Computer',
    song: 'Eins, Zwei, Dre',
  },
  france: {
    flag: '🇫🇷',
    country: 'France',
    contestant: 'Monroe',
    song: 'Regarde!',
  },
  moldova: {
    flag: '🇲🇩',
    country: 'Moldova',
    contestant: 'Satoshi',
    song: 'Viva, Moldova!',
  },
  finland: {
    flag: '🇫🇮',
    country: 'Finland',
    contestant: 'Linda Lampenius x Pete Parkkonen',
    song: 'Liekinheitin',
  },
  poland: {
    flag: '🇵🇱',
    country: 'Poland',
    contestant: 'Alicja',
    song: 'Bray',
  },
  lithuania: {
    flag: '🇱🇹',
    country: 'Lithuania',
    contestant: 'Lion Ceccah',
    song: 'Sólo quiero más',
  },
  sweden: {
    flag: '🇸🇪',
    country: 'Sweden',
    contestant: 'Felicia',
    song: 'My System',
  },
  cyprus: {
    flag: '🇨🇾',
    country: 'Cyprus',
    contestant: 'Antigoni',
    song: 'Jalla',
  },
  italy: {
    flag: '🇮🇹',
    country: 'Italy',
    contestant: 'Sal Da Vinci',
    song: 'Per sempre sì',
  },
  norway: {
    flag: '🇳🇴',
    country: 'Norway',
    contestant: 'Jonas Lovv',
    song: 'Ya Ya Ya',
  },
  romania: {
    flag: '🇷🇴',
    country: 'Romania',
    contestant: 'Alexandra Căpitănescu',
    song: 'Choke Me',
  },
};

export const runningOrder: (keyof typeof allCountries)[] = [
  'denmark',
  'germany',
  'israel',
  'belgium',
  'albania',
  'greece',
  'ukraine',
  'australia',
  'serbia',
  'malta',
  'czechia',
  'bulgaria',
  'croatia',
  'unitedKingdom',
  'france',
  'moldova',
  'finland',
  'poland',
  'lithuania',
  'sweden',
  'cyprus',
  'italy',
  'norway',
  'romania',
  'austria',
];

export const countries: typeof allCountries = runningOrder.reduce((agg, country) => {
  return {
    ...agg,
    [country]: allCountries[country],
  };
}, {});
